import React, { useEffect, useState } from 'react';
import { Button, Col, Row } from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEdit, faSave } from '@fortawesome/free-solid-svg-icons';

//Context
import { useAuth } from '../../../../../context/auth';

//Helpers
import { objCampo, validarCampos } from '../../../../../helpers/ValidadorDeCampos';

//Components
import TextField from "../../../../../components/TextField"
import roteiroDeFiscalizacao_api from '../../../../../api/roteiroDeFiscalizacao_api';
import { showMessage } from '../../../../../helpers/message';
import formulario_api from '../../../../../api/formulario_api';

function Identificacao({ roteiroFiscalizacao, setRoteiroFiscalizacao, loadRoteiroFiscalizacao, editavel }) {
    const { setLoading } = useAuth();

    //State para pegar formularios cadastrados
    const [listaFormularios, setListaFormularios] = useState([]);

    //Estado de controle dos erros
    const [errors, setErrors] = useState({});

    const loadFormulario = () => {
        formulario_api.GetListAtivosByFinalidade("Fiscalização").then(response => {
            response.data.map(value => {
                value.label = value.identificacao;
                value.value = value.id.toString();

                return value;
            })
            setListaFormularios(response.data);
        }).catch(ex => {
            showMessage("Erro", ex.message, 'error', null);
        })
    }

    useEffect(() => {
        loadFormulario();
    }, []);

    //Campos obrigatorios
    const camposIdentificacao = [
        objCampo({ name: "identificacao", required: true }),
        objCampo({ name: "status", required: true }),
        objCampo({ name: "situacaoInicial", required: true }),
        objCampo({ name: "formulario_Id", required: true })
    ];

    //Estado de controle do onChange
    const onChange = (e) => {
        const { name, value } = e.target;
        const _roteiroFiscalizacao = {
            ...roteiroFiscalizacao,
            [name]: value
        };

        //Validando erros no campo especifico para checar em tempo de digitação se ele possui algum erro
        const _campos = camposIdentificacao.filter(campo => campo.name === name);
        const fieldError = validarCampos(_roteiroFiscalizacao, _campos);

        const _errors = { ...errors };
        delete _errors[name];
        if (fieldError[1].length === 0)
            setErrors({ ..._errors });
        else
            setErrors({ ..._errors, ...fieldError[0] });

        setRoteiroFiscalizacao({
            ...roteiroFiscalizacao,
            [name]: value
        })
    }

    const onSubmit = async () => {
        const _roteiroFiscalizacao = { ...roteiroFiscalizacao };

        const _errorsRoteiroFiscalizacao = validarCampos(_roteiroFiscalizacao, camposIdentificacao);
        setErrors(_errorsRoteiroFiscalizacao[0]);

        if (_errorsRoteiroFiscalizacao[1].length > 0)
            return;

        delete _roteiroFiscalizacao.etapas;

        setLoading(true);

        //Recarrega antes de avisar: sem o await, o loading caía no finally enquanto o recarregamento
        //ainda estava em voo e a tela ficava com os dados antigos, parecendo que não salvou.
        try {
            if (_roteiroFiscalizacao.id) {
                await roteiroDeFiscalizacao_api.put(_roteiroFiscalizacao);
                await loadRoteiroFiscalizacao();
            } else {
                const response = await roteiroDeFiscalizacao_api.post(_roteiroFiscalizacao);
                await loadRoteiroFiscalizacao(response.data);
            }

            showMessage("Sucesso", "Operação realizada com sucesso", "success", null);
        } catch (err) {
            showMessage("Erro", err?.message ?? "Erro na operação.", "error", null);
        } finally {
            setLoading(false);
        }

        setRoteiroFiscalizacao(_roteiroFiscalizacao);
    }

    const onChangeFormularios = (value, e) => {
        const _roteiroFiscalizacao = {
            ...roteiroFiscalizacao,
            [e.name]: value ? value.value.toString() : null,
        };

        //Validando erros no campo especifico para checar em tempo de digitação se ele possui algum erro
        const _campos = camposIdentificacao.filter(campo => campo.name === e.name);
        const fieldError = validarCampos(_roteiroFiscalizacao, _campos);

        const _errors = { ...errors };
        delete _errors[e.name];
        if (fieldError[1].length === 0)
            setErrors({ ..._errors });
        else
            setErrors({ ..._errors, ...fieldError[0] });

        setRoteiroFiscalizacao(_roteiroFiscalizacao);
    }

    return <>
        <Row>
            <h5 className='mb-3'>Identificação do Fluxo Administrativo</h5>
            <Col md={12} lg={6}>
                <TextField
                    label={"* Identificação"}
                    name={"identificacao"}
                    maxLength={100}
                    onChange={onChange}
                    value={roteiroFiscalizacao.identificacao}
                    invalid={!!errors.identificacao}
                    disabled={!editavel}
                />
            </Col>
            <Col md={12} lg={6}>
                <TextField
                    type={"select"}
                    name={"formulario_Id"}
                    label={"* Formulário de Fiscalização"}
                    searchable
                    options={listaFormularios}
                    onChange={onChangeFormularios}
                    value={listaFormularios.filter(value => value.value == roteiroFiscalizacao.formulario_Id)}
                    invalid={!!errors.formulario_Id}
                    disabled={!editavel}
                />
            </Col>
            <Col md={12} lg={6}>
                <TextField
                    type={"text"}
                    name={"situacaoInicial"}
                    label={"* Situação Inicial"}
                    onChange={onChange}
                    value={roteiroFiscalizacao.situacaoInicial}
                    invalid={!!errors.situacaoInicial}
                    disabled={!editavel}
                />
            </Col>
            <Col md={12} lg={6}>
                <TextField
                    type={"select"}
                    name={"status"}
                    label="* Status"
                    options={
                        [
                            { label: "Ativo", value: "Ativo" },
                            { value: "Inativo", label: "Inativo" }
                        ]
                    }
                    onChange={onChange}
                    value={roteiroFiscalizacao.status}
                    invalid={!!errors.status}
                    disabled={!editavel}
                />
            </Col>
            <Col md="12" lg="12" className={`d-flex align-items-center justify-content-center ${editavel ? "" : "d-none"}`}>
                <Button
                    className='px-4'
                    color={roteiroFiscalizacao.id ? 'warning text-white' : 'success'}
                    onClick={onSubmit}
                    >
                    {roteiroFiscalizacao.id ? <><FontAwesomeIcon icon={faEdit} /> Atualizar</> : "+ Cadastrar"}
                </Button>
            </Col>
        </Row>
    </>;
}

export default Identificacao;